export default "__VITE_ASSET__1078c91d__"